import CantileverCard from 'components/CantileverCard'
import {
  createEditedObject,
  createUniqueFormFields,
} from 'components/form/formHelpers'
import { SimpleFormField } from 'components/form/formTypes'
import { EditDetectionConfigurationDataContext } from 'features/anomalyDetection/contexts/EditDetectionConfigurationDataLayer'
import { EditDetectionConfigurationUXContext } from 'features/anomalyDetection/contexts/EditDetectionConfigurationUXLayer'
import { DetectionConfigurationDataFromFormFields } from 'features/anomalyDetection/forms/detectionConfigurationFormFields'
import { EditSaveCancelButtons } from 'features/assetDatabase'
import React, { useContext } from 'react'
import { SubmitHandler } from 'react-hook-form'
import styled from 'styled-components'

import { EditDetectionConfigurationForm } from './EditDetectionConfigurationForm'

const FormContainer = styled.div`
  flex-direction: column;
  padding-top: 1rem;
  gap: 0;
`

export const EditDetectionConfigurationInfoCard: React.FC = () => {
  const { detectionConfigurationFormFields, setDetectionConfiguration } =
    useContext(EditDetectionConfigurationDataContext)

  const {
    inEditMode,
    handleEdit,
    handleSave,
    handleCancel,
    formRef,
    setInEditMode,
  } = useContext(EditDetectionConfigurationUXContext)

  const onSubmit: SubmitHandler<SimpleFormField> = (data) => {
    const convertedFormFields = createEditedObject(
      data,
      createUniqueFormFields(detectionConfigurationFormFields)
    )
    const configData = DetectionConfigurationDataFromFormFields(
      convertedFormFields[0].formFields
    )

    setDetectionConfiguration((prev) => ({
      ...prev,
      ...configData,
    }))

    setInEditMode(false)
  }

  return (
    <CantileverCard>
      <CantileverCard.CardHeader
        leadingContent='Basic Configuration'
        trailingContent={
          <EditSaveCancelButtons
            saveCancelButtons={inEditMode}
            formRef={formRef}
            handleSave={handleSave}
            handleEdit={handleEdit}
            handleCancel={handleCancel}
            formID='detectionConfigurationForm'
          />
        }
      />
      <CantileverCard.Section>
        <FormContainer>
          <EditDetectionConfigurationForm
            formFields={detectionConfigurationFormFields}
            inEditMode={inEditMode}
            ref={formRef}
            onSubmit={onSubmit}
          />
        </FormContainer>
      </CantileverCard.Section>
    </CantileverCard>
  )
}
